import { apiClient } from '@/lib/api-client';
import type { ApiResponse } from '@/types/api';
import type { User, CreateUserRequest, UpdateUserRequest } from '@/types/user';

export async function getUsers(): Promise<ApiResponse<User[]>> {
  const response = await apiClient.get<ApiResponse<User[]>>('/users');
  return response.data;
}

export async function getUser(id: number): Promise<ApiResponse<User>> {
  const response = await apiClient.get<ApiResponse<User>>(`/users/${id}`);
  return response.data;
}

export async function createUser(data: CreateUserRequest): Promise<ApiResponse<User>> {
  const response = await apiClient.post<ApiResponse<User>>('/users', data);
  return response.data;
}

export async function updateUser(
  id: number,
  data: UpdateUserRequest
): Promise<ApiResponse<null>> {
  const response = await apiClient.put<ApiResponse<null>>(`/users/${id}`, data);
  return response.data;
}

export async function deleteUser(id: number): Promise<ApiResponse<null>> {
  const response = await apiClient.delete<ApiResponse<null>>(`/users/${id}`);
  return response.data;
}

export async function changePassword(id: number, newPassword: string): Promise<ApiResponse<null>> {
  const response = await apiClient.patch<ApiResponse<null>>(`/users/${id}/password`, { newPassword });
  return response.data;
}
